import type { LocationDistrictLink, LocationPlaceLink } from "./locations/types";

export const districtPath = (district: LocationDistrictLink) => `/${district.slug}-elektrikci`;

export const placePath = (district: LocationDistrictLink, place: LocationPlaceLink) =>
  place.type === "mahalle"
    ? `/${district.slug}-${place.slug}-mahallesi-elektrikci`
    : `/${place.slug}-elektrikci`;

export const placeLabel = (place: LocationPlaceLink) =>
  place.type === "mahalle" ? `${place.name} Mahallesi` : place.name;

export const locationAreaName = (district: LocationDistrictLink, place?: LocationPlaceLink) => {
  if (!place) return district.name;
  const placeName = place.titleName ?? placeLabel(place);
  return placeName.toLocaleLowerCase("tr-TR").startsWith(district.name.toLocaleLowerCase("tr-TR"))
    ? placeName
    : `${district.name} ${placeName}`;
};

export const locationKeyword = (district: LocationDistrictLink, place?: LocationPlaceLink) =>
  `${locationAreaName(district, place)} Elektrikçi`;